import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { ErrorOverlayComponent } from './error-overlay/error-overlay.component';
import { MultiSelectModule } from './multi-select/multi-select.module';
import { ChipSearchInputComponent } from './chip-search-input/chip-search-input.component';
import { ReadersModalComponent } from './readers-modal/readers-modal.component';
import { ReauthModalComponent } from './reauth-modal/reauth-modal.component';

@NgModule({
  declarations: [
    LoadingOverlayComponent,
    ErrorOverlayComponent,
    ReadersModalComponent,
    ReauthModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MultiSelectModule,
    ChipSearchInputComponent
  ],
  exports: [
    LoadingOverlayComponent,
    ErrorOverlayComponent,
    MultiSelectModule,
    ChipSearchInputComponent,
    ReadersModalComponent,
    ReauthModalComponent
  ]
})
export class SharedComponentsModule { }
